import './KeywordInput.css';

export default function KeywordInput({
  label,
  values = ['', '', ''],
  onChange,
  error,
  maxLength = 30,
  className = ''
}) {
  const handleChange = (index, newValue) => {
    const newValues = [...values];
    newValues[index] = newValue;
    onChange?.(newValues);
  };

  return (
    <div className={`keyword-input ${error ? 'keyword-input--error' : ''} ${className}`}>
      {label && <label className="keyword-input__label">{label}</label>}
      <div className="keyword-input__fields">
        {[0, 1, 2].map((index) => (
          <div key={index} className="keyword-input__field">
            <span className="keyword-input__number">{index + 1}</span>
            <input
              type="text"
              value={values[index] || ''}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={`Keyword ${index + 1}`}
              maxLength={maxLength}
              className="keyword-input__input"
            />
            {values[index] && (
              <span className="keyword-input__count">
                {values[index].length}/{maxLength}
              </span>
            )}
          </div>
        ))}
      </div>
      {error && (
        <span className="keyword-input__error" role="alert">
          {error}
        </span>
      )}
      <p className="keyword-input__hint">
        Optional: Three words that capture the essence of your brand's vibe
      </p>
    </div>
  );
}
